module.exports = __webpack_public_path__ + "static/image4-66e36667f365f98d465ff4cdc7c9c492.png";